<ul fxLayout="row wrap" fxLayoutAlign="center center" id="footer">

    <li fxFlex="60" fxFlex.md="100" fxLayoutGap="3%" id="team" fxLayout="row wrap" fxLayoutAlign="center start">
        <span fxFlex="30">
            "Apolonia" Associazione Socio-Culturale <br> Via Panama 30R <br> 86039 Termoli (CB) Italia <br> C.F.: IT 91054310700 <br> Tel.+39 345 9140329 <br>
        </span>
        <span fxFlex="30" fxLayout="column" fxLayoutAlign="center center">
            <p>SOCIAL MEDIA</p>
            <!--Facebook-->
            <a href="https://www.facebook.com/scuolapolacca" target="_blank" class="icon" style="color:#01bacf">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"><path d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z" /></svg>
                <span>Facebook</span>
        </a>
        <!--Instagram-->
        <a href="https://www.instagram.com/scuolapolacca/" target="_blank" class="icon" style="color:#ce74e7">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"><path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" /></svg>
            <span>Instagram</span>
        </a>
        </span>

        <span fxFlex="30" fxLayout="column" fxLayoutAlign="center center">
            <span>NAJWAŻNIEJSZE LINKI</span>

        <a (click)="forceNavigate('what')">O nas</a>


        <a (click)="forceNavigate('whatWeDo')">Oferta</a>

        <a (click)="forceNavigate('who')">Kadra</a>

        <a (click)="forceNavigate('question')">Kontakt</a>

        </span>

        <span fxFlex="100" style="font-size:x-small">
            * - Projekty współfinansowane ze środków polonijnych MSZ
        </span>
    </li>

</ul>